import { Badges } from "./Badges";
import { Benefits } from "./Benefits";
import { Countdown } from "./Countdown";
import { Detailed } from "./Detailed";
import { List } from "./List";
import { MediaBlockProperties } from "./MediaBlockProperties";
import { PaywallCustomizationContext } from "./PaywallCustomizationProvider";
import { PriceCallout } from "./PriceCallout";
import { ReducedPrice } from "./ReducedPrice";
import { Testimonials } from "./Testimonials";

export const PaywallCustomization = Object.assign(List, {
  Badges,
  Benefits,
  Countdown,
  List,
  PriceCallout,
  Provider: PaywallCustomizationContext,
  ReducedPrice,
  Testimonials,

  // Upsells only
  Detailed,
  MediaBlockProperties,
});
